<template>
    <div class="d-flex justify-content-center">
        <div class="card">

            <div class="card-body">
                <h1 class="card-title">Create Profile</h1>
                <p class="card-subtitle mb-2 text-muted">A user profile is required for the portal, please complete the
                    information below.</p>

                <div class="bg-light" style="padding: 30px;">
                    <form ref="form" @submit.prevent="saveProfile">
                        <div class="form-row">
                            <div class="col-sm-5 col-md-6">
                                <div class="form-group">
                                    <label for="firstName" class="hec-label-required">First Name</label>
                                    <input type="text" required class="form-control" id="firstName"
                                        v-model="profileDetails.firstName"
                                        :class="{ 'is-invalid': $v.profileDetails.firstName.$error }" maxlength="50">
                                    <span v-if="!profileDetails.firstName.required" class="invalid-feedback">First Name is
                                        required</span>
                                </div>
                            </div>
                            <div class="col-sm-5 col-md-6">
                                <div class="form-group "><!--row2 -->
                                    <label for="lastName" class="hec-label-required">Last Name</label>
                                    <input type="text" required class="form-control" id="lastName"
                                        v-model="profileDetails.lastName"
                                        :class="{ 'is-invalid': $v.profileDetails.lastName.$error }" maxlength="50">
                                    <span v-if="!profileDetails.lastName.required" class="invalid-feedback">Last Name is
                                        required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 col-md-12">
                                <div class="form-group "><!--row2 -->
                                    <label for="email" class="hec-label-required">Email Address</label>
                                    <input type="email" required class="form-control" id="email"
                                        v-model="profileDetails.email"
                                        :class="{ 'is-invalid': $v.profileDetails.email.$error }" maxlength="100">
                                    <span v-if="!profileDetails.email.required" class="invalid-feedback">Email Address is
                                        required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 col-md-12">
                                <div class="form-group "><!--row2 -->
                                    <label for="organizationName" class="hec-label-required">Organization Name</label>
                                    <input type="text" required class="form-control" id="organizationName"
                                        v-model="profileDetails.organizationName"
                                        :class="{ 'is-invalid': $v.profileDetails.organizationName.$error }" maxlength="255">
                                    <span v-if="!profileDetails.organizationName.required"
                                        class="invalid-feedback">Organization Name is required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 col-md-12">
                                <div class="form-group "><!--row2 -->
                                    <label for="address" class="hec-label-required">Address 1</label>
                                    <input type="text" required class="form-control" id="address"
                                        v-model="profileDetails.address1"
                                        :class="{ 'is-invalid': $v.profileDetails.address1.$error }" maxlength="120">
                                    <span v-if="!profileDetails.address1.required" class="invalid-feedback">Address 1 is
                                        required</span>
                                </div>

                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 col-md-12">
                                <div class="form-group "><!--row2 -->
                                    <label for="address1">Address 2</label>
                                    <input type="text" class="form-control" id="address1" v-model="profileDetails.address2" maxlength="120">
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-4 col-md-5">
                                <div class="form-group">
                                    <label for="city" class="hec-label-required">City</label>
                                    <input type="text" required class="form-control" id="city" v-model="profileDetails.city"
                                        :class="{ 'is-invalid': $v.profileDetails.city.$error }" maxlength="50">
                                    <span v-if="!profileDetails.city.required" class="invalid-feedback">City is
                                        required</span>
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3">
                                <div class="form-group "><!--row2 -->
                                    <label for="state" class="hec-label-required">State</label>
                                    <input type="text" required class="form-control" id="state" v-model="profileDetails.contatState"
                                        :class="{ 'is-invalid': $v.profileDetails.contatState.$error }">
                                    <span v-if="!profileDetails.contatState.required" class="invalid-feedback">State is
                                        required</span>
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-4">
                                <div class="form-group "><!--row2 -->
                                    <label for="postal" class="hec-label-required">Postal Code</label>
                                    <input type="text" required class="form-control" id="postal"
                                        v-model="profileDetails.zip"
                                        :class="{ 'is-invalid': $v.profileDetails.zip.$error }" v-mask="'#####'">
                                    <span v-if="!profileDetails.zip.required" class="invalid-feedback">Postal Code is
                                        required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-3 col-md-5">
                                <div class="form-group">
                                    <label for="phoneNumber" class="hec-label-required">Phone Number</label>
                                    <input type="text" class="form-control" id="phoneNumber"
                                        v-model="profileDetails.phoneNumber"
                                        :class="{ 'is-invalid': $v.profileDetails.phoneNumber.$error }" v-mask="'###-###-####'">
                                    <span v-if="!profileDetails.phoneNumber.required" class="invalid-feedback">Phone Number
                                        is
                                        required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col">
                                <div class="d-flex flex-row py-3">
                                    <div class="mr-2">
                                        <b-button variant="primary" v-on:click="saveProfile">Save Changes</b-button>
                                    </div>
                                    <div>
                                        <b-button variant="secondary" v-on:click="cancelCreateProfile">Cancel</b-button>
                                    </div>
                                </div>                                
                            </div>                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import lambdaURL from '../../lambdahcetx'
import { required, minLength, email, requiredIf } from 'vuelidate/lib/validators';

export default {
    mounted() {

    },
    data() {
        return {
            profileDetails: {
                email: '',
                firstName: '',
                lastName: '',
                organizationName: '',
                address1: '',
                address2: '',
                city: '',
                contatState: '',
                zip: '',
                phoneNumber: ''
            }
        }
    },
    validations: {
        profileDetails: {
            firstName: {
                required, minLength: minLength(1)
            },
            lastName: {
                required, minLength: minLength(1)
            },
            email: {
                required, email, minLength: minLength(1),
            },
            organizationName: {
                required, minLength: minLength(1)
            },
            address1: {
                required, minLength: minLength(1)
            },
            address2: {
                required: false, minLength: minLength(1)
            },
            contatState: {
                required, minLength: minLength(2)
            },
            city: {
                required, minLength: minLength(1)
            },
            phoneNumber: {
                required, minLength: minLength(12)
            },
            zip: {
                required,
                minLength: minLength(5)
            }
        },
        form: ['profileDetails'],
    },
    methods: {
        isRequired(value) {
            return value ? true : 'This field is required';
        },
        focusFirstStatus() {
            var errorElements = document.querySelectorAll(".is-invalid");
            if (errorElements && errorElements.length > 0) {
                var elmnt = document.getElementById(errorElements[0].id);
                elmnt.scrollIntoView();
            }
        },
        validate() {
            this.$v.form.$touch();
            var isValid = !this.$v.form.$invalid;
            this.$emit('on-validate', this.$data, isValid);
            this.$nextTick(() => this.focusFirstStatus());
            return isValid
        },
        saveProfile: function () {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.hasError = true;
            } else {
                const insertResponse = lambdaURL.insertHceTxContact(this.profileDetails.email, this.profileDetails.firstName, this.profileDetails.lastName, this.profileDetails.organizationName, this.profileDetails.address1, this.profileDetails.address2, this.profileDetails.city, this.profileDetails.contatState, this.profileDetails.zip, this.profileDetails.phoneNumber, this.$keycloak.userName);
                console.log(JSON.stringify(insertResponse));
                if (insertResponse !== null) {
                    window.location.href = '/hce/home';
                }
            }
        },
        cancelCreateProfile: function () {
            window.location.href = '/';
        }
    }
}
</script>